import Helper from './Helper';
import Player from '@vimeo/player';

class HeroVideo {

  constructor() {
    const videos = Array.prototype.slice.call(document.querySelectorAll('.ns-hero__video'));

    videos.forEach((video) => {
      if (video) {
        bindEvents()
      }
    })

    function bindEvents() {
      const thumbnail = Array.prototype.slice.call(document.querySelectorAll('.ns-video__thumbnail'));
      const playbuttonHero = Array.prototype.slice.call(document.querySelectorAll('.ns-hero__playbutton'));
      let running = false;

      thumbnail.forEach(button => {
        button.addEventListener('click', () => {
          const video = button.parentElement;
          const iframe = video.querySelector('iframe');
          button.classList.add('fade-out');
          button.style.display = 'none';
          running = !running;

          if (button.nextElementSibling.classList.contains("paused")) {
            button.nextElementSibling.classList.remove("paused");
            iframe.contentWindow.postMessage('{"method":"pause"}', "*");
          }
          iframe.contentWindow.postMessage('{"method":"play"}', "*");
          button.nextElementSibling.classList.add("paused");
        });
      });

      playbuttonHero.forEach(btn => {
        const iframe = btn.parentNode.querySelector('iframe');

        btn.addEventListener('click', event => {
          const thumbnail = btn.previousElementSibling;
          thumbnail.classList.add('fade-out');

          if (running) {
            iframe.contentWindow.postMessage('{"method":"pause"}', "*");
            btn.classList.remove("paused");
          } else {
            iframe.contentWindow.postMessage('{"method":"play"}', "*");
            btn.classList.add("paused");
          }
          running = !running;
        })
      });
    }

  }
}

export default HeroVideo;
